export function topicNameFromNcId(ncId: string) {
    return `/${ncId.replace(/[^a-zA-Z0-9-_.~%]+/g, '')}`;
}
